import {useThemeColors} from '@nfq/colors';

/**
 * Custom hook that provides theme colors for tab cloud view components.
 *
 * @returns An object containing the theme colors.
 */
export const useTabCloudView = () => {
    const colors = useThemeColors();

    return {colors};
};